/*
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-06-26 12:42:04
 * @LastEditors: wang.zhiqin wang.zhiqin@trs.com.cn
 * @LastEditTime: 2025-04-25 14:18:12
 * @FilePath: \jsczt_vue\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import '../src/assets/global.css'
import store from './store'
import 'core-js'
import 'regenerator-runtime/runtime'
import 'lib-flexible'
import './plugins/vant'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

import VueRouter from 'vue-router'
Vue.use(MintUI)
const EventBus = new Vue()
Vue.use({install (Vue) {
  Vue.prototype.EventBus = EventBus
}})

Vue.use(ElementUI)
Vue.prototype.$http = axios
Vue.config.productionTip = false

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.prototype.addData = function (item) {
  this.$http.post('/yjsUbas/yjs/add', {
    browserVersion: navigator.appVersion,
    browserName: navigator.appName,
    browserLanguage: navigator.language,
    areaCode: this.$route.query.code,
    areaName: this.choicePlace,
    // deptCode:item.deptcode,
    // deptName:item.deptname,
    // unitCode:"",
    // unitName:"",
    areaYear: this.$route.query.year == '自定义' ? localStorage.getItem('rangeyear') : this.$route.query.year,
    sourceType: 6,
    fileType: item,
    url: window.location.href
  }).then(res => {
    // if (res.data.code === 200) {
    // this.listData = res.data.data
  }
  )
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js